import { render } from "./BriefCase.vue?vue&type=template&id=83750ea8"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/BriefCase.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "83750ea8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('83750ea8', __exports__)) {
    api.reload('83750ea8', __exports__)
  }
  
  module.hot.accept("./BriefCase.vue?vue&type=template&id=83750ea8", () => {
    api.rerender('83750ea8', render)
  })

}


export default __exports__